import { Box, CardMedia, Paper, Stack, TextField, Typography } from "@mui/material";
import { userState, scrapInfoType } from "../../../interface/MainInterface";
import "./CardBtnScrap.css";
import { useEffect, useRef, useState } from "react";
import { HttpUnAuthApi } from "../../../interface/unauth-api";
import LoadingCircle from "../../../utils/LoadingCircle";
import ToastCustom from "../../../utils/ToastCustom";
import { useWindowSize } from "../../../utils/useWindowSize";
import dayjs from "dayjs";

interface propsType {
  userState: userState;
  scrapInfo: scrapInfoType;
  selectedScrapInfo: any;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const maxImageCount = 4;

const CardBtnScrap = (props: propsType) => {
  const windowSize = useWindowSize();
  const toastRef: any = useRef();
  const scrapTitleRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const [scrapTitle, setScrapTitle] = useState("");
  const [editTitle, setEditTitle] = useState(false);

  useEffect(() => {
    return () => {
      setIsLoading(false);
      setEditTitle(false);
    };
  }, []);

  useEffect(() => {
    setScrapTitle(props.scrapInfo.scrap_title);
  }, [props.scrapInfo.scrap_title]);

  const delete_scrap_info = async (e: React.MouseEvent) => {
    e.stopPropagation(); // 부모창 클릭이벤트 전달 방지

    // 먼저 confirm을 처리하고, 이후에 비동기 코드 실행 (iOS 18.6.2 버전에서 동작하지 않아서 confirmed 처리)
    const confirmed = window.confirm("선택하신 스크랩보드를 삭제하시겠습니까?\n삭제한 데이터는 복구할 수 없습니다.");
    if (!confirmed) return;

    const param: any = {
      command: "delete_scrap_info",
      pk: props.scrapInfo.pk,
      sk: props.scrapInfo.sk,
      user_id: props.userState.id,
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      toastRef.current?.toast("스크랩보드가 삭제되었습니다.", "success", 4000, {
        vertical: "bottom",
        horizontal: "center",
      });
      props.callback({ command: "finish_delete_scrap_info" });
    } else {
      toastRef.current?.toast("스크랩보드 삭제에 실패했습니다.", "error", 4000, {
        vertical: "bottom",
        horizontal: "center",
      });
    }
  };

  const boxClick = (e: any) => {
    if (props.selectedScrapInfo?.pk === props.scrapInfo.pk && props.selectedScrapInfo?.sk === props.scrapInfo.sk) {
      props.callback({ command: "select_scrap_info", value: null });
    } else props.callback({ command: "select_scrap_info", value: props.scrapInfo });
  };

  const update_scrap_title = async () => {
    if (props.scrapInfo.scrap_title === scrapTitle) {
      setEditTitle(false);
      return;
    }

    const param: any = {
      command: "update_scrap_title",
      pk: props.scrapInfo.pk,
      sk: props.scrapInfo.sk,
      new_title: scrapTitle,
      user_id: props.userState.id,
    };
    setIsLoading(true);
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      props.callback({ command: "update_title" });
      setEditTitle(false);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Paper
        className={
          props.selectedScrapInfo?.pk === props.scrapInfo.pk && props.selectedScrapInfo?.sk === props.scrapInfo.sk
            ? "scrap-box-wrapper scrap-box-select"
            : "scrap-box-wrapper"
        }
        elevation={0}
      >
        <Box sx={{ width: "100%", cursor: "pointer" }} onClick={boxClick}>
          <Box sx={{ p: "16px" }}>
            <Stack direction={windowSize.width > 300 ? "row" : "column"} spacing={0}>
              <Box
                sx={{
                  width: windowSize.width > 1023 ? "220px" : "130px",
                  display: "flex",
                  position: "relative",
                  borderRadius: "8px",
                  height: windowSize.width > 1023 ? "calc(155px - 34px)" : "88px",
                }}
              >
                {props.scrapInfo.default_image_list.length === 0 && (
                  <Box
                    sx={{
                      width: "100%",
                      height: windowSize.width > 1023 ? "calc(155px - 34px)" : "88px",
                      borderRadius: "8px",
                      border: "2px solid rgba(255, 255, 255, 1)",
                      display: "flex",
                      justifyContent: "center",
                      backgroundColor: "rgba(232, 232, 232, 1)",
                    }}
                  >
                    <CardMedia
                      component={"img"}
                      image={"/images/no-image.png"}
                      sx={{
                        width: "40%",
                        maxWidth: "180px",
                        objectFit: "contain",
                        boxSizing: "border-box",
                      }}
                    />
                  </Box>
                )}
                {props.scrapInfo.default_image_list.map(
                  (image_url: string, index: number) =>
                    index < maxImageCount && (
                      <Box
                        key={`default-img-${index}`}
                        sx={{
                          position: "absolute",
                          left:
                            windowSize.width > 1023
                              ? `calc(0px + ${
                                  (index * (220 - 120)) /
                                  (props.scrapInfo.default_image_list.length > maxImageCount
                                    ? maxImageCount - 1
                                    : props.scrapInfo.default_image_list.length - 1)
                                }px)`
                              : `calc(0px + ${
                                  (index * (130 - 71)) /
                                  (props.scrapInfo.default_image_list.length > maxImageCount
                                    ? maxImageCount - 1
                                    : props.scrapInfo.default_image_list.length - 1)
                                }px)`,
                          zIndex: `${900 - index}`,
                        }}
                      >
                        {image_url === "none" || image_url === undefined ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignContent: "center",
                              background: "rgba(232, 232, 232, 1)",
                              height: windowSize.width > 1023 ? "calc(155px - 34px)" : "88px",
                              borderRadius: "8px",
                              border: "2px solid rgba(255, 255, 255, 1)",
                              width:
                                props.scrapInfo.default_image_list.length > 1
                                  ? windowSize.width > 1023
                                    ? "120px"
                                    : "71px"
                                  : windowSize.width > 1023
                                  ? "220px"
                                  : "130px",
                              boxSizing: "border-box",
                            }}
                          >
                            <CardMedia component={"img"} image={"/images/no-image.png"} className="noImage" />
                          </Box>
                        ) : (
                          <CardMedia
                            component={"img"}
                            image={image_url}
                            sx={{
                              height: windowSize.width > 1023 ? "calc(155px - 34px)" : "88px",
                              borderRadius: "8px",
                              border: "2px solid rgba(255, 255, 255, 1)",
                              width:
                                props.scrapInfo.default_image_list.length > 1
                                  ? windowSize.width > 1023
                                    ? "120px"
                                    : "71px"
                                  : windowSize.width > 1023
                                  ? "220px"
                                  : "130px",
                              boxSizing: "border-box",
                            }}
                            onError={(e) => {
                              e.currentTarget.src = "/images/no-image.png";
                              e.currentTarget.className = "noImage";
                            }}
                          />
                        )}
                      </Box>
                    )
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: windowSize.width > 1023 ? `calc(100% - 220px)` : windowSize.width > 300 ? `calc(100% - 130px)` : null,
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ p: windowSize.width > 1023 ? "8px 16px 8px 16px" : "8px 0px 8px 16px" }}>
                    <Stack direction={"column"} spacing={windowSize.width > 1023 ? "12px" : "10px"}>
                      <Box>
                        {!editTitle ? (
                          <Typography
                            sx={{
                              maxWidth: "calc(100% - 1px)",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              fontSize: windowSize.width > 1023 ? "18px" : "16px",
                              fontWeight: "700",
                              lineHeight: windowSize.width > 1023 ? "23.4px" : "20.8px",
                              cursor: "text",
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // 부모창 클릭이벤트 전달 방지
                              setEditTitle(true);
                            }}
                          >
                            {scrapTitle}
                          </Typography>
                        ) : (
                          <TextField
                            inputRef={scrapTitleRef}
                            className="scrap-title"
                            value={scrapTitle}
                            autoFocus
                            onChange={(e) => {
                              setScrapTitle(e.target.value);
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // 부모창 클릭이벤트 전달 방지
                            }}
                            onKeyUp={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                scrapTitleRef.current.blur();
                              }
                            }}
                            onBlur={(e) => {
                              e.preventDefault();
                              update_scrap_title();
                            }}
                            inputProps={{
                              style: {
                                fontSize: windowSize.width > 1023 ? "18px" : "16px",
                                fontWeight: "700",
                                lineHeight: windowSize.width > 1023 ? "23.4px" : "20.8px",
                                padding: 0,
                              },
                              enterKeyHint: "Enter",
                            }}
                          ></TextField>
                        )}
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: windowSize.width > 1023 ? "14px" : "13px",
                            fontWeight: "500",
                            lineHeight: windowSize.width > 1023 ? "18.2px" : "16.9px",
                            color: "rgba(138, 138, 138, 1)",
                          }}
                        >{`${dayjs(props.scrapInfo.sk).format("YYYY-MM-DD HH:mm")} 생성됨`}</Typography>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        {props.scrapInfo.scrap_status === "REQUEST_REPORT" ? (
                          <Box className="btn-delete" sx={{ cursor: "pointer", display: "flex" }}>
                            {windowSize.width > 1023 && (
                              <Typography
                                className="btn-delete-text"
                                sx={{
                                  fontSize: windowSize.width > 1023 ? "16px" : "13px",
                                  fontWeight: "500",
                                  lineHeight: windowSize.width > 1023 ? "19px" : "16.9px",
                                  color: "rgba(138, 138, 138, 1)",
                                }}
                              >
                                {"레포트 생성중..."}
                              </Typography>
                            )}
                          </Box>
                        ) : (
                          <Box className="btn-delete" sx={{ cursor: "pointer", display: "flex" }}>
                            <CardMedia
                              className="btn-delete-img"
                              component={"img"}
                              image="/images/svg-delete.svg"
                              sx={{ height: "18px", width: "18px" }}
                              onClick={delete_scrap_info}
                            />
                            {windowSize.width > 1023 && (
                              <Typography
                                className="btn-delete-text"
                                sx={{
                                  fontSize: windowSize.width > 1023 ? "16px" : "13px",
                                  fontWeight: "500",
                                  lineHeight: windowSize.width > 1023 ? "19px" : "16.9px",
                                  color: "rgba(138, 138, 138, 1)",
                                }}
                                onClick={delete_scrap_info}
                              >
                                {"삭제"}
                              </Typography>
                            )}
                          </Box>
                        )}
                      </Box>
                    </Stack>
                  </Box>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Paper>
      <ToastCustom ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

export default CardBtnScrap;
